import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  getData,
  getColumns, getIsLoading,
} from '../redux/selectors/MrdMonitoringReportsAllIssuesSelectors';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/list-table/components/ListTable';
import MonitoringReportRefreshTimer from '../../component/MonitoringReportRefreshTimer';
import { MonitoringReportStyle } from '../../component/MrdMonitoringReport.styles';

function MrdMonitoringReportsAllIssuesContainer(props) {
  const {
    isLoading,
    columns,
    data,
    tableLoad,
    tableId,
  } = props;
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    setTableData(data.map((item) => {
      const downloadIssueReported = item.issueReported ? 'YES' : 'NO';
      if (item.issueReported !== null) {
        return {
          ...item,
          downloadIssueReported,
        };
      }
      return item;
    }));
  }, [data]);
  return (
    <MonitoringReportStyle>
      <MonitoringReportRefreshTimer doRefresh={() => { tableLoad(tableId); }} />
      <ListTable
        listId={TableDefinitions.MRD_MONITORING_REPORT_ALL_ISSUES.id}
        loading={isLoading}
        columns={columns}
        data={tableData}
        isDownloadEnable
        downloadFileAs="MRD_MONITORING_REPORT"
        downloadFileTemplate="MRD_MONITORING_REPORT"
      />
    </MonitoringReportStyle>
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    isLoading: getIsLoading(state),
  };
}

MrdMonitoringReportsAllIssuesContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  tableLoad: PropTypes.func,
  tableId: PropTypes.string,
};

export default connect(mapStateToProps)(MrdMonitoringReportsAllIssuesContainer);
